import { IconClose, Header, HintTitle, HintList, Subtitle, Title, Wrapper } from './styled'
import { animated, easings, useSpring } from '@react-spring/web'
import { ReactHintModal } from 'component/Modal/HintModal'
import { useCallback } from 'react'
import { ButtonWrapper, CancelButton, ConfirmButton } from 'component/Modal/ConfirmModal/Styled'
import useOpenModal from 'page/SystemConfig/hooks/useOpenModal'
import { Styles } from 'react-modal'

export default function SafetyModal({
  isOpen,
  onOpenCard,
  onClose,
}: {
  isOpen: boolean
  onClose: () => void
  onOpenCard: () => void
}) {
  const { openIDCard } = useOpenModal()
  const styles: Styles = {
    overlay: {
      zIndex: 101,
      backgroundColor: 'rgba(16, 4, 27, 0.5)',
      width: '100vw',
      height: '100vh',
    },
    content: {
      width: '7.55rem',
      height: '5.55rem',
      transformOrigin: 'center',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: 0,
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      borderRadius: '0.25rem',
      transition: 'transform 0.3s ease-out',
    },
  }
  const springStyles = useSpring({
    config: { duration: 150, easing: easings.easeInCubic },
    width: '100%',
    height: isOpen ? '100%' : '0',
    opacity: isOpen ? 1 : 0.2,
  })

  const onConfirm = useCallback(() => {
    openIDCard()
    onOpenCard()
    onClose()
  }, [onClose, onOpenCard, openIDCard])

  return (
    <>
      {isOpen ? (
        <ReactHintModal
          contentLabel="Hint Modal"
          isOpen={isOpen}
          style={styles}
          shouldCloseOnOverlayClick={false}
          onRequestClose={onClose}
        >
          <animated.div style={springStyles}>
            <Wrapper className={'rotateClassName'}>
              <IconClose onClick={onClose} />
              <Header>
                <Title>资金安全</Title>
                <Subtitle>因资金安全建议您先保存身份卡</Subtitle>
              </Header>
              <ButtonWrapper>
                <CancelButton onClick={onClose}>继续充值</CancelButton>
                <ConfirmButton onClick={onConfirm}>保存身份卡</ConfirmButton>
              </ButtonWrapper>
              <HintTitle>找回账号小贴士：</HintTitle>
              <HintList>1.请务必保存好身份卡</HintList>
              <HintList>2.请勿外流身份卡</HintList>
            </Wrapper>
          </animated.div>
        </ReactHintModal>
      ) : (
        <></>
      )}
    </>
  )
}
